// Step 2
// Personal user Details

import React, { useState, useEffect, useRef } from "react";
import ErrorComponent from "../UI/error";
import InputFields from "../../common/input";
import clsx from "clsx";
import {
  State,
  Country,
  Postcode,
  City,
  Home,
  CheckBoxTick,
  CheckBoxBlank,
  MapMarker,
  HelpOutline,
} from "../../common/icons";

export default function SecondaryAddressStep({
  currentStep,
  inputSecondaryAddressBillingEl,
  inputSecondaryAddressEl,
  handleSecondaryAddressInput,
  secondaryAddressInput,
  secondaryCheckboxAddress,
  handleSecondaryCheckboxAddress,
  secondaryInputRef,
  onSubmitAddressDetails,
  inputFields,
  billingAddress,
  secondaryAddressFind,
  secondaryFindMyaddessInGoogle,
  stepNo,
  handleSecondaryBillingAddressInput,
  goNextStep,
  handleCardCheckBox,
  localStorageDatas,
  isSecondaryDigitalCard,
  languages,
  secondaryGoogleAddressEmpty,
}) {
  if (currentStep !== stepNo) {
    return null;
  }

  var isDigitalCard = false;
  var itemData = "";
  var itemIndex = "";

  localStorageDatas.members.map((item, index) => {
    isDigitalCard =
      localStorageDatas.business_categories[
        item.selected_product[0].business_category_id
      ]?.card_delivery_selectable;
    itemData = item;
    itemIndex = index;
  });

  return (
    <div className="flex justify-evenly align-center tablet:mt-5 tablet:mx-10">
      <form
        id="address-details"
        className="w-full tablet:px-10"
        onSubmit={onSubmitAddressDetails}
      >
        {
          // (secondaryAddressInput !== null && !secondaryFindMyaddessInGoogle) ? (
          !secondaryFindMyaddessInGoogle ? (
            <>
              <InputFields
                inputFields={inputFields}
                inputChange={handleSecondaryAddressInput}
                inputEl={inputSecondaryAddressEl}
              />
              {isDigitalCard ? (
                <>
                  <div className="flex items-center mt-3 mb-3">
                    <button
                      id={`link-${itemIndex}`}
                      type="button"
                      checked={isSecondaryDigitalCard}
                      onClick={() =>
                        handleCardCheckBox(itemData, itemIndex, "supp")
                      }
                      className="d-none w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                    />
                    <label
                      htmlFor={`link-${itemIndex}`}
                      className="link-checkbox text-sm font-medium text-gray-900 dark:text-gray-300"
                    >
                      <span
                        className={`checkbox-icon ${isSecondaryDigitalCard} mr-4`}
                      >
                        {isSecondaryDigitalCard ? (
                          <CheckBoxTick />
                        ) : (
                          <CheckBoxBlank />
                        )}
                      </span>
                      {/* <span>Do you want to receive a physical membership card?</span> */}
                      {/* <span>Your digital card will be available in the ALL APP. Do you want to receive a physical card as well?</span> */}
                      <span>
                        {languages.physicalCardTickbox
                          ? languages.physicalCardTickbox
                          : "Do you want to receive a physical membership card?"}
                      </span>
                    </label>
                  </div>
                  {/* {
                                        isSecondaryDigitalCard ? (
                                            <InputFields 
                                                inputFields={billingAddress} 
                                                inputChange={handleSecondaryBillingAddressInput}
                                                inputEl={inputSecondaryAddressBillingEl}
                                            />
                                        ) : ''
                                    } */}
                  {isSecondaryDigitalCard ? (
                    <>
                      <div className="flex items-center my-5">
                        <input
                          id="link-checkbox"
                          type="checkbox"
                          checked={secondaryCheckboxAddress}
                          onClick={handleSecondaryCheckboxAddress}
                          className="w-4 h-4 text-blue-600 d-none bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                        />
                        <label
                          htmlFor="link-checkbox"
                          className="link-checkbox flex items-center text-sm font-medium text-gray-900 dark:text-gray-300"
                        >
                          <span className="checkbox-icon mr-4">
                            {secondaryCheckboxAddress ? (
                              <CheckBoxTick />
                            ) : (
                              <CheckBoxBlank />
                            )}
                          </span>
                          <span className="text-gray">
                            {languages.sameBillingAddress &&
                            languages.sameBillingAddress
                              ? languages.sameBillingAddress
                              : "My shipping address is the same as my address."}
                          </span>
                        </label>
                      </div>
                      {secondaryCheckboxAddress ? null : (
                        <InputFields
                          inputFields={billingAddress}
                          inputChange={handleSecondaryBillingAddressInput}
                          inputEl={inputSecondaryAddressBillingEl}
                        />
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}
              {/* <div className="flex items-center my-5">
                            
                            <input 
                            id="link-checkbox" 
                            type="checkbox" 
                            checked={secondaryCheckboxAddress}
                            onClick={handleSecondaryCheckboxAddress}
                            className="w-4 h-4 text-blue-600 d-none bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" 
                            />
                            <label htmlFor="link-checkbox" className="link-checkbox flex items-center text-sm font-medium text-gray-900 dark:text-gray-300">
                            <span className='checkbox-icon mr-4'>{ secondaryCheckboxAddress ? <CheckBoxTick /> : <CheckBoxBlank />}</span>
                            <span className='text-gray'>
                                {languages.sameBillingAddress && languages.sameBillingAddress ? languages.sameBillingAddress : 'My shipping address is the same as my address.'}
                            </span>
                            </label>
                        </div>  

                        {
                            secondaryCheckboxAddress ? null : (
                            <InputFields 
                                inputFields={billingAddress} 
                                inputChange={handleSecondaryBillingAddressInput}
                                inputEl={inputSecondaryAddressBillingEl}
                            />
                            )
                        } */}
            </>
          ) : (
            <>
              <div className="input-fields flex items-center mb-2">
                <label htmlFor="simple-search" className="sr-only">
                  {" "}
                </label>
                <div className="relative w-full">
                  <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                    <MapMarker />
                  </div>
                  <input
                    ref={secondaryInputRef}
                    placeholder="Address*"
                    className={clsx(
                      "bg-gray-50 border border-gray-300 text-gray text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    )}
                  />
                </div>
              </div>
              <div className="mb-2">
                {secondaryGoogleAddressEmpty && (
                  <ErrorComponent
                    errorMessage={
                      "This field is mandatory and must be filled out."
                    }
                    languages={languages}
                  />
                )}
              </div>
              <div className="flex items-center my-5 px-2">
                <HelpOutline />
                <span
                  onClick={secondaryAddressFind}
                  className="flex items-center text-sm font-medium text-gray-900 dark:text-gray-300 pl-2 pointer: cursor-pointer"
                >
                  {languages.noGoogleAddress && languages.noGoogleAddress
                    ? languages.noGoogleAddress
                    : "I can't find my address"}
                </span>
              </div>
            </>
          )
        }
      </form>
    </div>
  );
}
